//import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Session } from './lib/session';
import React, { useState, useEffect } from 'react';

//@ts-ignore
//import css from './index.css';






function Root () {
    const [userToken, setUserToken] = useState('');

    useEffect(() => {
        // 使用 URLSearchParams 解析當前網址的查詢參數
        const queryParams = new URLSearchParams(window.location.search);
        const token = queryParams.get('user_token'); // 獲取 'user_token' 的值
        console.log("useEffect")
        console.log("token:"+token)
        // 設置 userToken 狀態
        if (token) {
            console.log("useEffect")
        console.log("token:"+token)
          setUserToken(token);
        }
      }, []);
      
    console.log("root")
    const unsupported = typeof BigInt !== 'function';
    return (() => {
        if (unsupported) {
            alert('您的瀏覽器版本太舊，請改用 Chrome, Firefox, 或 Edge 瀏覽器');
            return <></>;
        } else {

            
            checkSession(userToken); // 改直接調用 checkSession 函數
            
            return <Content/>;
        }
    })();
}


function getCurrentUserID(){
    console.log("getCurrentUserID")
    return Session.load()
    .map(session => {
        return session
        .map(sess => (sess.user.id))
        .orElse('!');
    }).orElse('!')
}

function checkSession(userToken:string) {
    console.log("checkSession.....")
    const sess = Session.load().orError();
    if (sess.present) {
        console.log("有session")
        if(userToken==='' || userToken===null || userToken===undefined){
            console.log("沒有userToken")
            document.location.href = 'api/v1/tproof/checkuserid/'+getCurrentUserID();
        }else{
            console.log("有userToken:"+userToken)
            localStorage.removeItem("session"); //有user token , 先清除本地端 session , 再呼叫api/v1/tproof/verify?user_token=建立新的session 給前端
            document.location.href = 'api/v1/tproof/verify?user_token='+userToken;
        }
        
        
    } else {
        console.log("沒有session")
        
        if(userToken==='' || userToken===null || userToken===undefined){
            console.log("沒有userToken")
            document.location.href = 'api/v1/tproof/verify';
        }else{
            console.log("有userToken:"+userToken)
            document.location.href = 'api/v1/tproof/verify?user_token='+userToken;
        }
       
        
    }
}



function Content () {
    return (<></>);
}

ReactDOM.render(
    
    <Root/>,
    document.getElementById('root'));
